import { SharedIcon } from 'components/SharedIcon/SharedIcon';
import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';

type ActiveFilterChip = {
  filterName: string;
  filterValue: string;
  onRemove: () => void;
};

type ActiveFilterChipsProps = {
  chips: ActiveFilterChip[];
  addFilterDropdown?: React.ReactNode;
};

export function ActiveFilterChips({
  chips,
  addFilterDropdown,
}: ActiveFilterChipsProps) {
  const hasContent = chips.length > 0 || addFilterDropdown;

  if (!hasContent) return null;

  return (
    <div className="d-flex flex-wrap gap-2 align-items-center">
      {chips.map((chip) => (
        <div
          key={`${chip.filterName}-${chip.filterValue}`}
          className="d-inline-flex align-items-center gap-2 px-2 py-1 rounded border border-neutral-600 bg-neutral-800 text-white"
        >
          <span>
            <span className="fw-semibold">{chip.filterName}</span>
            {' is '}
            <span>{chip.filterValue}</span>
          </span>
          <StylishNewButton
            className="button--icon text-light p-0 border-0"
            style={{ width: 'unset', height: 'unset' }}
            onClick={(e) => {
              e.stopPropagation();
              chip.onRemove();
            }}
            aria-label={`Remove ${chip.filterName} filter`}
          >
            <SharedIcon iconName="close" size="sm" />
          </StylishNewButton>
        </div>
      ))}
      {addFilterDropdown}
    </div>
  );
}
